import { Component, OnInit, Input } from '@angular/core';
import { Customer } from 'src/app/models/Customer';

@Component({
  selector: 'customer-box',
  templateUrl: './customer-box.component.html',
  styleUrls: ['./customer-box.component.css']
})
export class CustomerBoxComponent implements OnInit {
  @Input() customer: Customer;
  mouseIn: number;
  constructor() { }

  ngOnInit(): void {
  }

}
